import Sticky from 'sticky-js'

if (document.querySelector('.sticky')) {
    const sticky = new Sticky('.sticky');
}
